module.exports = __webpack_public_path__ + "static/media/size.9835457f.svg";